module.exports = __webpack_public_path__ + "static/media/structure_am_big.5a4cc713.png";